var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view',{attrs:{"name":"Header"}}),_c('div',{attrs:{"id":"developer"}},[_vm._v("This website was created by Adele Angel")]),_c('router-view'),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }